import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useApi from "./useApi";
import { toast } from "react-toastify";
import {
    IconButton,
    Modal,
    Box,
    Typography,
    Button,
    TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const Subcontractors = () => {
    const { projectId, packageId } = useParams();
    const [newSubcontractorName, setNewSubcontractorName] = useState("");
    const [editName, setEditName] = useState("");
    const [{ data: subcontractors, loading }, callApi] = useApi();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [currentSubcontractor, setCurrentSubcontractor] = useState(null);

    useEffect(() => {
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors`,
        });
    }, [projectId, packageId, callApi]);

    const handleCreateSubcontractor = (e) => {
        e.preventDefault();
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors`,
            method: "POST",
            body: { name: newSubcontractorName },
        }).then(() => {
            toast.success("Subcontractor created successfully!");
            setNewSubcontractorName("");
            callApi({
                url: `/api/projects/${projectId}/packages/${packageId}/subcontractors`,
            });
        });
    };

    const openDeleteModalHandler = (subcontractor) => {
        setCurrentSubcontractor(subcontractor);
        setOpenDeleteModal(true);
    };

    const closeDeleteModalHandler = () => {
        setOpenDeleteModal(false);
    };

    const handleDeleteSubcontractor = () => {
        if (currentSubcontractor) {
            callApi({
                url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${currentSubcontractor.id}`,
                method: "DELETE",
            }).then(() => {
                toast.success("Subcontractor deleted successfully!");
                callApi({
                    url: `/api/projects/${projectId}/packages/${packageId}/subcontractors`,
                });
                closeDeleteModalHandler();
            });
        }
    };

    const openEditModalHandler = (subcontractor) => {
        setCurrentSubcontractor(subcontractor);
        setEditName(subcontractor.name);
        setOpenEditModal(true);
    };

    const closeEditModalHandler = () => {
        setOpenEditModal(false);
    };

    const handleEditSubcontractor = (e) => {
        e.preventDefault();
        if (currentSubcontractor) {
            callApi({
                url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${currentSubcontractor.id}`,
                method: "PUT",
                body: { name: editName },
            }).then(() => {
                toast.success("Subcontractor name updated successfully!");
                callApi({
                    url: `/api/projects/${projectId}/packages/${packageId}/subcontractors`,
                });
                closeEditModalHandler();
            });
        }
    };

    return (
        <div className="content-container">
            <h2>
                Subcontractors for Package {packageId} in Project {projectId}
            </h2>
            {loading && <div>Loading...</div>}
            <form
                onSubmit={handleCreateSubcontractor}
                className="form-container"
            >
                <input
                    type="text"
                    placeholder="Subcontractor Name"
                    value={newSubcontractorName}
                    onChange={(e) => setNewSubcontractorName(e.target.value)}
                    required
                    className="form-input"
                />
                <button type="submit" className="form-button">
                    Create New Subcontractor
                </button>
            </form>
            <ul className="item-list">
                {Array.isArray(subcontractors) ? (
                    subcontractors.map((subcontractor) => (
                        <li key={subcontractor.id} className="list-item">
                            <Link
                                to={`/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractor.id}/documents`}
                                className="item-link"
                            >
                                {subcontractor.name}
                            </Link>
                            <IconButton
                                onClick={() =>
                                    openEditModalHandler(subcontractor)
                                }
                                size="small"
                            >
                                <EditIcon />
                            </IconButton>
                            <IconButton
                                onClick={() =>
                                    openDeleteModalHandler(subcontractor)
                                }
                                size="small"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </li>
                    ))
                ) : (
                    <p>No subcontractors found.</p>
                )}
            </ul>
            {/* Delete Confirmation Modal */}
            <Modal
                open={openDeleteModal}
                onClose={closeDeleteModalHandler}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal">
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        Confirm Deletion
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Are you sure you want to delete this subcontractor?
                    </Typography>
                    <Button onClick={handleDeleteSubcontractor} color="error">
                        Delete
                    </Button>
                    <Button onClick={closeDeleteModalHandler}>Cancel</Button>
                </Box>
            </Modal>
            {/* Edit Subcontractor Modal */}
            <Modal
                open={openEditModal}
                onClose={closeEditModalHandler}
                aria-labelledby="edit-modal-title"
                aria-describedby="edit-modal-description"
            >
                <Box className="modal">
                    <Typography
                        id="edit-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        Edit Subcontractor Name
                    </Typography>
                    <form onSubmit={handleEditSubcontractor}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            label="Subcontractor Name"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                        />
                        <Button type="submit" color="primary">
                            Update
                        </Button>
                        <Button onClick={closeEditModalHandler}>Cancel</Button>
                    </form>
                </Box>
            </Modal>
        </div>
    );
};

export default Subcontractors;
